<!--
/**
 * DjBatchRechargeTab.vue - 批量充值 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的批量充值页面，
 * 支持通过上传Excel文件批量为号码充值，同时展示历史批量充值记录
 * （包含成功/失败数量和金额统计）。
 *
 * 【主要功能】
 * 1. 批量充值记录列表 - 展示历史批量充值的批次、数量、成功/失败金额等统计
 * 2. 批量充值操作 - 通过上传xlsx文件执行批量充值
 * 3. 模板下载 - 提供批量充值模板文件下载
 * 4. 结果下载 - 下载各批次的充值结果数据
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 -->
<template>
  <div>
    <!-- ========== 操作按钮区域 ========== -->
    <div class="handle-box">
      <!-- 批量充值按钮 - 打开上传弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" @click="getaddVisible">批量充值</el-button>
      <!-- 下载批量充值模板 -->
      <a :href="`${path}batchRecharge.xlsx`" class="down" :class="[theme]" style="margin:10px 10px;"
         download="批量充值模板.xlsx">
        <i class="el-icon-download"></i>
        下载模板
      </a>
      <!-- 刷新按钮 -->
      <el-button size="small" type="primary" :class="[theme]" @click="batchTopUpRecords">刷新</el-button>
    </div>

    <!-- ========== 批量充值记录表格 ========== -->
    <el-table :data="batchtableData" border class="table" ref="multipleTable"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 处理批次号 -->
      <el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
      <!-- 总数量 -->
      <el-table-column prop="count" label="总数量" align="center"></el-table-column>
      <!-- 成功数量 -->
      <el-table-column prop="success" label="成功" align="center"></el-table-column>
      <!-- 成功金额 -->
      <el-table-column prop="totalSuccess" label="成功金额(元)" align="center"></el-table-column>
      <!-- 失败数量（红色显示） -->
      <el-table-column prop="err" label="失败" align="center">
        <template #default="scope">
          <span style="color: #f56c6c;">{{ scope.row.err }}</span>
        </template>
      </el-table-column>
      <!-- 失败金额（红色显示） -->
      <el-table-column prop="totalErr" label="失败金额(元)" align="center">
        <template #default="scope">
          <span style="color: #f56c6c;">{{ scope.row.totalErr }}</span>
        </template>
      </el-table-column>
      <!-- 时间 -->
      <el-table-column prop="time" label="时间" align="center" width="180"></el-table-column>
      <!-- 操作者 -->
      <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
      <!-- 操作列 - 下载结果数据 -->
      <el-table-column label="操作" width="240" align="center">
        <template #default="scope">
          <a :href="scope.row.url" class="down" :class="[theme]" download="迪迦批量充值数据.text">
            <i class="el-icon-download"></i>
            下载
          </a>
        </template>
      </el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="batchquery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="batchquery.pageSize" :total="batchpageTotal" @size-change="batchhandleSizeChange"
                     @current-change="batchhandlePageChange"></el-pagination>
    </div>

    <!-- ========== 批量充值弹窗 ========== -->
    <!-- 通过上传xlsx文件进行批量充值 -->
    <el-dialog title="批量充值" v-model="addVisible7" width="520px" @close="closeDialog7">
      <el-form label-width="120px" :model="addForm7" ref="addForm7">
        <!-- 文件上传（只能导入xlsx文件） -->
        <el-form-item label="上传文件" prop="">
          <el-upload ref="upload7" action="/api/dxt/batchTopUp" :headers="token" :limit="1"
                     :on-success="uploadSuccess7" :auto-upload="false" :data="uploadData7">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入xlsx文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog7">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="submitUpload7">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 批量充值 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - batchTopUpRecord：查询批量充值记录列表
 */
import {
  batchTopUpRecord
} from '../../../api/dijia.js';

export default {
  name: 'DjBatchRechargeTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - path：静态资源路径（用于下载模板文件）
   * - token：请求头信息，用于文件上传鉴权
   */
  props: {
    theme: { type: String, default: '' },
    path: { type: String, default: '' },
    token: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      batchquery: {             // 查询参数
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
      },
      batchtableData: [],       // 批量充值记录列表
      batchpageTotal: 0,        // 总条数

      // ========== 批量充值弹窗相关 ==========
      addVisible7: false,       // 弹窗是否显示
      uploadData7: {            // 文件上传附加数据
        userId: localStorage.getItem('user'),
      },
    };
  },

  /**
   * 组件创建时查询批量充值记录列表
   */
  created() {
    this.batchTopUpRecords();
  },

  methods: {
    /**
     * batchTopUpRecords - 查询批量充值记录列表
     */
    batchTopUpRecords() {
      this.loading = true;
      batchTopUpRecord(this.batchquery).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.batchtableData = res.data.list;
          this.batchpageTotal = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getaddVisible - 打开批量充值弹窗
     */
    getaddVisible() {
      this.addVisible7 = true;
    },

    /**
     * closeDialog7 - 关闭批量充值弹窗
     */
    closeDialog7() {
      this.addVisible7 = false;
    },

    /**
     * submitUpload7 - 触发文件上传
     * 检查是否选择了文件后提交上传
     */
    submitUpload7() {
      if (this.$refs.upload7.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload7.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },

    /**
     * uploadSuccess7 - 文件上传成功回调
     * @param {Object} success - 上传接口返回结果
     */
    uploadSuccess7(success) {
      setTimeout(() => {
        this.$refs.upload7.clearFiles();
        this.addVisible7 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.batchTopUpRecords();
      } else {
        this.$message.error(success.message);
      }
    },

    /**
     * batchhandlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    batchhandlePageChange(val) {
      this.batchquery.pageIndex = val;
      this.batchTopUpRecords();
    },

    /**
     * batchhandleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    batchhandleSizeChange(val) {
      this.batchquery.pageSize = val;
      this.batchquery.pageIndex = 1;
      this.batchTopUpRecords();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
